import * as React from 'react'
import {FC, useEffect, useContext, useRef, useCallback} from 'react'
import { useInView } from 'react-intersection-observer'

import { TitleContext } from '../TitleDetails'

import './Section.scss'

interface Props {
    id: string
    children?: React.ReactNode
    className?: string
    style?: React.CSSProperties
}

const Section: FC<Props> = ({ children, id, className, style }) => {
    const threshold = 0.01;

    const [sectionRef, sectionInView, sectionEntry] = useInView({ threshold, rootMargin: '0%' })
    const {getHighestIntersection, setIntersectionRatio, sectionMinHeight} = useContext(TitleContext)

    useEffect(() => {
        if (sectionEntry && id) {
            setIntersectionRatio(id, sectionInView ? sectionEntry.intersectionRatio : 0.0);
        }
    }, [sectionRef, id, sectionInView, getHighestIntersection, setIntersectionRatio, sectionEntry])

    return (
        <section
            id={id}
            className={`Section ${className}`}
            ref={sectionRef}
            style={{ minHeight: sectionMinHeight, ...style }}
        >
            {children}
        </section>
    )
}

export default Section
